import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ClinicService } from 'src/app/_services/clinic.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-update-nurse',
  templateUrl: './update-nurse.component.html',
  styleUrls: ['./update-nurse.component.scss'],
})
export class UpdateNurseComponent implements OnInit {
  loading: boolean = false;
  submitted: boolean = false;
  nurseData: any;

  sancQualifications = [
    {
      label: 'OHC',
      value: 'OHC',
    },
    {
      label: 'PHC',
      value: 'PHC',
    },
    {
      label: 'RN',
      value: 'RN',
    },
    {
      label: 'RM',
      value: 'RM',
    },
    {
      label: 'ADV Midwife',
      value: 'ADV Midwife',
    },
    {
      label: 'COM',
      value: 'COM',
    },
    {
      label: 'OHNP',
      value: 'OHNP',
    },
    {
      label: 'Ed et ADM',
      value: 'Ed et ADM',
    },
    {
      label: 'ADM',
      value: 'ADM',
    },
    {
      label: 'PSYC',
      value: 'PSYC',
    },
    {
      label: 'NA',
      value: 'NA',
    },
    {
      label: 'OPTH',
      value: 'OPTH',
    },
    {
      label: 'CCRN',
      value: 'CCRN',
    }

  ];

  userForm = this.fb.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    username: ['', Validators.required],
  });

  nurseDetailForm = this.fb.group({
    contact_number: ['', Validators.required],
    alternate_contact_number: [''],
    sanc_qualification: [[] as string[]],
    sanc_number: ['', Validators.required],
    practice_number: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private clinicService: ClinicService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    // Get nurse data passed from parent component
    this.nurseData = this.config.data?.nurse;
    
    console.log('Nurse Data for Editing:', this.nurseData);
    

    if (this.nurseData) {
      // Populate user form
      this.userForm.patchValue({
        first_name: this.nurseData.user?.first_name || '',
        last_name: this.nurseData.user?.last_name || '',
        email: this.nurseData.user?.email || '',
        username: this.nurseData.user?.username || '',
      });

      // Populate nurse detail form - handle both nested and flat structures
      const nurseDetails = this.nurseData.nurse_details || this.nurseData;
      
      // Convert sanc_qualification from comma-separated string to array
      let sancQualificationArray: string[] = [];
      if (nurseDetails?.sanc_qualification) {
        if (typeof nurseDetails.sanc_qualification === 'string') {
          sancQualificationArray = nurseDetails.sanc_qualification
            .split(',')
            .map((q: string) => q.trim())
            .filter((q: string) => q.length > 0);
        } else if (Array.isArray(nurseDetails.sanc_qualification)) {
          sancQualificationArray = nurseDetails.sanc_qualification;
        }
      }
      
      this.nurseDetailForm.patchValue({
        contact_number: nurseDetails?.contact_number || '',
        alternate_contact_number: nurseDetails?.alternate_contact_number || '',
        sanc_qualification: sancQualificationArray,
        sanc_number: nurseDetails?.sanc_number || '',
        practice_number: nurseDetails?.practice_number || '',
      });
    }
  }

  get f() {
    return this.userForm.controls;
  }

  closeDialog() {
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;

    console.log('User Form Value:', this.userForm.value);
    console.log('Nurse Detail Form value:', this.nurseDetailForm.value);

    if (this.userForm.invalid || this.nurseDetailForm.invalid) {
      console.log('Form is invalid');
      console.log('User Form values:', this.userForm.value);
      console.log('Nurse Detail Form values:', this.nurseDetailForm.value);
      return;
    }

    this.loading = true;

    const nurseId = this.nurseData.nurse_details?.user.id || this.nurseData.user.id;

    // Get nurse detail form values
    const nurseFormValues = this.nurseDetailForm.value;
    
    // Convert sanc_qualification array back to comma-separated string for API
    const sancQualificationString = Array.isArray(nurseFormValues.sanc_qualification)
      ? nurseFormValues.sanc_qualification.join(',')
      : nurseFormValues.sanc_qualification;

    // Transform forms to match API requirements
    const updateData = {
      ...nurseFormValues,
      sanc_qualification: sancQualificationString,
      user: {
        id: this.nurseData.user?.id,
        ...this.userForm.value,
      },
    };

    console.log('Submitting Update Data:', updateData);

    this.clinicService.updateNurse(nurseId, updateData).subscribe(
      (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Nurse updated successfully',
          key: 'nurseUpdate',
        });
        this.loading = false;
        this.ref.close(response);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update nurse',
          key: 'nurseUpdate',
        });
        this.loading = false;
        console.error('Error updating nurse:', error);
      }
    );
  }
}
